import React from 'react';
import PropTypes from 'prop-types';
import flatten from 'lodash/flatten';
import { useSelector } from 'react-redux';
import { selectRoles, selectCheckHousehold } from '@stores/auth/selectors.js';
import { RoleService } from '@core/roles/RoleService.js';
import { getChannelFromProfiles } from '@helpers/roleUtils.js';

const AuthorizationSecurity = ({
  component: Component,
  scopes,
  channelMap = null,
  profileCodeMap = null,
  specialCheck = null,
}) => {
  const profileRoles = useSelector(selectRoles);
  const isHousehold = useSelector(selectCheckHousehold);

  if (specialCheck === 'household') {
    if (isHousehold !== true) {
      return null;
    }
  }
  const roles = flatten(scopes);

  if (RoleService.hasRole(roles, profileRoles)) {
    const channel = channelMap
      ? RoleService.getChannelFromRoles(profileRoles, channelMap)
      : getChannelFromProfiles(profileRoles);
    const profileCode = profileCodeMap
      ? RoleService.getProfileCodeFromRoles(profileRoles, profileCodeMap)
      : null;
    return <Component channel={channel} profileCode={profileCode} />;
  }
  window.location.replace('/sales-portal/home'); // Replaces current history entry (preferred for auth redirects)

  return null;
};

AuthorizationSecurity.propTypes = {
  component: PropTypes.any,
  scopes: PropTypes.any,
  channelMap: PropTypes.object,
  specialCheck: PropTypes.any,
};

export default React.memo(AuthorizationSecurity);
